module.exports = __webpack_public_path__ + "img/mic-mute.66f21508.svg";